'use strict';

export let ArticuloRouteComponent = {
    selector: 'articuloRoute',
    template: require('./articulo-route.html'),
    bindings: {
        articulo: '='
    },
    controller: class{
        
        /*@ngInject*/
        constructor(CarritoService, $location, $window, Auth){
            Object.assign(this, {CarritoService, $location, $window});
            this.isAdmin = Auth.isAdminSync;
        }

        $onInit(){
            this.articulo.cantidad = 1;
            this.$window.scrollTo(0,0);
        }
        
        agregarArticuloAlCarrito(){
            this.CarritoService.agregarArticulo(this.articulo);
            this.$location.path('/carrito');
        }

    }
};


// WEBPACK FOOTER //
// ./client/app/articulo-route/ver/articulo-route.component.js